'use strict'

import _ from 'lodash'

const CACHE_KEY = '_API_store_'

export const fetchCache = ($input, value) => {
    const store = $input.data(CACHE_KEY) ?? {}
    return _.has(store, value) ? Promise.resolve(store[value]) : Promise.reject(null)
}

export const setCache = ($input, value, data) => {
    $input._dataExtend(CACHE_KEY, value, data)
    return data
}
